import $ from 'jquery';
//import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

//require('foundation-sites');
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

//import './lib/modernizr';
import 'slick-carousel';
//import Shuffle from 'shufflejs';
import 'magnific-popup';
//import MonthPicker from './lib/vanilla-monthpicker';
//import './lib/jquery.paroller';
//import './lib/readmore.js';
//import lax from 'lax.js';
//import ActiveMenuLink from "active-menu-link";

$(document).foundation();

window.onbeforeunload = function () {
    //window.scrollTo(0, 0);
};
// store the hash (DON'T put this code inside the $() function, it has to be executed
// right away before the browser can start scrolling!
var target = window.location.hash,
    target = target.replace('#', '');
// delete hash so the page won't scroll to it
//window.location.hash = "";

//nur letzten Resize-Event nehmen
var delay = (function(){
    var timerResize = 0;
    return function(callback, ms){
        clearTimeout (timerResize);
        timerResize = setTimeout(callback, ms);
    };
})();
var resized = false;
var lastView = '';
$(window).resize(function() {
    delay(function () {
        reInit();
    }, 500);
});
var viewed = false;
var directionsDisplay;
var directionsService;
var geocoder;
var map;
var end;

const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
};

//orientation change
window.addEventListener("orientationchange", function() {
    setTimeout("reInit()",100);
}, false);

function reInit() {
    if (lastView != getLastView()) {
        location.reload();
    }
    init();
}
function init() {
    documentHeight();
    lastView = getLastView();
    window.addEventListener("resize", function() {
        //textTeaserUpdates();
    });
    //textTeaserUpdates();

    setTimeout(function() {
        //startAnimations();
    }, 500);

    //loadShuffle();
    //debug browser window size
    var viewportWidth = $(window).width();
    var viewportHeight = $(window).height();
    $("#debug-size").html(viewportWidth+'x'+viewportHeight);
}

$( document ).ready(function() {

    init();

    loadSliders();

    loadMasonry();

    // Scroll-Effekt
    jQuery('a.scroll, li.scroll>a, nav a').on("click touchstart", function(event) {
        var ziel = jQuery(this).attr("href");
        if (!isSameSite(ziel)) {
            if (!isMobile()) {
                sleep(1000);
            } else {
                window.location = ziel;
            }
            return true;
        } else {
            //jQuery(this).parent().addClass('active');
        }

        var regex_hash = /(?:#)([A-Za-z0-9]+)/g;
        var hash = regex_hash.exec(ziel);
        if (hash !== null && hash[1] !== '') {
            sleep(1000);
            scroll(hash[1]);
            return false;
        }
    });

    // Nav
    $('.menub').on('click touchstart',function (el) {
        const icon = $(this).find('.menu-icon');
        const site = $('.all-wrapper');
        const nav = $('.nav-wrapper');
        icon.addClass('activated');
        if (icon.hasClass('active')) {
            site.removeClass('active');
            icon.removeClass('active');
            if (isMobile()) {
                nav.fadeOut('fast');
            } else {
                nav.fadeOut('slow');
            }
        } else {
            site.addClass('active');
            icon.addClass('active');
            if (isMobile()) {
                window.scrollTo(0, 0);
                nav.fadeIn(0);
            } else {
                nav.fadeIn('slow');
            }
        }
        return false;
    });

    $('nav a').on('click touchstart',function (el) {
        closeNav();
    });
    // end Nav

    //read more
    $('.text-more').each(function() {
        var moreText = $(this).find('.more');
        var btnText = $(this).find('.button-readmore');
        moreText.hide();
        btnText.css("display","block");
        btnText.on('click', function() {
            if (moreText.css('display') === "none") {
                moreText.show();
                btnText.addClass('open');
                btnText.html('Schließen');
            } else {
                moreText.hide();
                btnText.removeClass('open');
                btnText.html('Mehr dazu');
                var back = btnText.data('ref');
                if (back) {
                    //console.log(scroll);
                    scroll(back);
                }
            }
        });
    });

    if (isTouch()) {
        $('.tooltip').on('touchstart',function (el) {
            const tt = $(this);
            if (tt.hasClass('open')) {
                tt.removeClass('open');
                tt.next().slideUp();
            } else {
                $('.tooltip').removeClass('open');
                $('.tooltip').next().slideUp();
                tt.addClass('open');
                tt.next().slideDown();
            }
        });

    } else {
        $('.tooltip').on('click',function (el) {
            const tt = $(this);
            if (tt.hasClass('open')) {
                tt.removeClass('open');
                tt.next().slideUp();
            } else {
                $('.tooltip').removeClass('open');
                $('.tooltip').next().slideUp();
                tt.addClass('open');
                tt.next().slideDown();
            }
        });
    }


    $('.gallery-opener').each(function () { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a', // the selector for gallery item
            type: 'image',
            gallery: {
                titleSrc: 'alt',
                enabled:true,
                tPrev: 'Zur&uuml;ck', // title for left button
                tNext: 'Vor', // title for right button
                tCounter: '%curr% von %total%', // markup of counter
                closeOnBgClick: true
            },
            callbacks: {
                buildControls: function () {
                    // re-appends controls inside the main container
                    if (this.arrowLeft && this.arrowRight) {
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    }
                },
            }
        });
    });

    //Google maps
    if ($('#map').length>0) {
        loadGoogleMaps();
        jQuery('.privacy-proxy-map-button--accept').on('click', function() {
            loadGoogleMaps();
        });
    }

    $('#route').on('submit', function(e) {
        if (loadGoogleMaps()) {
            calcRoute();
        }
        return false;
    });

    // Scroll-Down-Button
    var mywindow = $(window);
    var contentTimeline = $('.content-wrapper>section:not("#t2")');
    var contentTimeline2 = $('.content-wrapper>section>div.grey-wrapper');
    var down = $('.down:not(".down-extra")>a');
    var activeContent = "";

    //Setup waypoints plugin
    Waypoint.destroyAll();

    contentTimeline.each(function(el) {
        new Waypoint({
            element: $(this),
            handler: function () {
                if ($(this.element).data('pos') > -1) {
                    activeContent = $(this.element).data('pos');
                } else {
                    activeContent = -1;
                }
                downButtonVisible();
            },
            offset: 300
        });
    });

    //waypoints doesnt detect the first slide when user scrolls back up to the top so we add this little bit of code, that removes the class
    //from navigation link slide 2 and adds it to navigation link slide 1.
    mywindow.scroll(function () {
        if (mywindow.scrollTop() <= 200) {
            activeContent = -1;
            downButtonVisible();
        }
    });
    down.unbind("click");
    down.on('click touch',function (e) {
        e.preventDefault();
        if (activeContent == -1) {
            var next = 1;
        } else {
            var next = (activeContent+1);
        }
        var nextSlide = $("#s" + next);
        if (nextSlide.length) {
            var offset = 68;
            if (activeContent < 0) {
                var offset = 70;
            }
            jQuery('html, body').animate({scrollTop: nextSlide.offset().top - offset}, 1000);
            activeContent = next;
            downButtonVisible();
        }
        return false;
    });
    function downButtonVisible() {
        var nextSlide = $("[data-pos='" + (activeContent+1) + "']");
        if (nextSlide.length) {
            down.show();
            return true;
        } else {
            down.hide();
            return false;
        }
    }

    // end Scroll-Down-Button

    //Hyphenate
    $('.box-item .title, .first-header, .first-header b, .title-wrapper h1, h1, h2, h3, .line3, .line2, .third-header, .third-header b, .second-header, .second-header b, td, td>p, .col-item p, div.hyphenate, span.hyphenate, label').hyphenate('de');

    if (isAndroid()) {
        $('body').addClass('isAndroid');
    }
    if (isMobileSafari()) {
        $('body').addClass('isMobileSafari');
    }
    if (isMacChrome()) {
        $('body').addClass('isMacChrome');
    }

});

//https://css-tricks.com/making-a-masonry-layout-that-works-today/
function loadMasonry() {
    const masonryLayouts = document.querySelectorAll('.masonry-container')

    masonryLayouts.forEach(async container => {
        if (isMasonrySupported(container)) return

        const colGap = parseFloat(getComputedStyle(container).columnGap)
        const items = getChildren(container)

        container.style.gridAutoRows = '0px'
        container.style.setProperty('row-gap', '1px', 'important')

        try {
            await Promise.all([areImagesLoaded(container), areVideosLoaded(container)])
        } catch(e) {}

        layout({colGap, items})


        const observer = new ResizeObserver(observerFn)
        observer.observe(container)

        function observerFn(entries) {
            for (const entry of entries) {
                layout({colGap, items})
            }
        }
    })

    function isMasonrySupported(container) {
        if (typeof window === 'undefined') return
        return getComputedStyle(container).gridTemplateRows === 'masonry'
    }

    function getChildren(container) {
        let children = container.children

        // Compensate for Astro Slots
        if (children[0]?.nodeName === 'ASTRO-SLOT') children = children[0].children
        return Array.from(children)
    }

    async function areImagesLoaded(container) {
        const images = Array.from(container.querySelectorAll('img'))
        const promises = images.map(img => {
            return new Promise((resolve, reject) => {
                if (img.complete) return resolve()
                img.onload = resolve
                img.onerror = reject
            })
        })
        return Promise.all(promises)
    }

    function areVideosLoaded(container) {
        const videos = Array.from(container.querySelectorAll('video'))
        const promises = videos.map(video => {
            return new Promise((resolve, reject) => {
                if (video.readyState === 4) return resolve() // HAVE_ENOUGH_DATA
                video.onloadedmetadata = resolve
                video.onerror = reject
            })
        })
        return Promise.all(promises)
    }

    async function layout({colGap, items}) {
        items.forEach(item => {
            const ib = item.getBoundingClientRect()
            item.style.gridRowEnd = `span ${Math.round(ib.height + colGap)}`
        })
    }
}

function sleep(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
}

window.addEventListener('load', loadFunctions);

function loadFunctions() {
    if (target) {
        //open news video
        if (target.includes('video_') && jQuery('#' + target).length) {
            setTimeout(function() {
                jQuery('#' + target).magnificPopup('open');
            }, 2000);
        } else {
            scroll(target);
        }
    }

    startAnimations();
    loadMasonry();

    //faq close button
    $(window).on(
        'down.zf.accordion', function (el) {
            $(el.target).find('.close').on('click', function(el2) {
                $(el.target).foundation('up', $(this).parent());
            });
        }
    );
}

function loadSliders() {
    if (!isMobile()) {
        $('.hero-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: false,
            autoplay: true,
            autoplaySpeed: 5500,
            dots: true,
            arrows:false,
            infinite: true,
            speed: 1000,
            lazyLoad: 'ondemand',
            lazyLoadBuffer: 0,
            rows: 0,
        });
    } else {
        $('.hero-slider-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: false,
            autoplay: true,
            autoplaySpeed: 5500,
            dots: true,
            arrows:false,
            infinite: true,
            speed: 1000,
            lazyLoad: 'ondemand',
            lazyLoadBuffer: 0,
            rows: 0,
        });
    }
    $('.hero-text-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: false,
        arrows:false,
        infinite: true,
        speed: 1000,
        lazyLoad: 'ondemand',
        lazyLoadBuffer: 0,
        rows: 0,
    });

    $('.cite-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        fade: false,
        autoplay: false,
        autoplaySpeed: 3000,
        dots: true,
        arrows:true,
        infinite: true,
        speed: 1000,
        lazyLoad: 'ondemand',
        lazyLoadBuffer: 0,
        rows: 0,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]

    });
}


function closeNav() {
    $('.menub').click();
}

function scroll(hash) {
    let h = jQuery('#' + hash);
    //console.log('scroll:'+hash);
    if (h.length) {
        let offset = 80;
        jQuery('html, body').animate({scrollTop: h.offset().top - offset}, 1000);
        window.location.hash = "";
    }
}

function isSameSite(url) {
    if (url.charAt(0) === '#') return true;
    try {
        var hrefURL, pageURL;
        hrefURL = new URL(url);
        pageURL = new URL(window.location);

        if (hrefURL.host !== pageURL.host || hrefURL.pathname !== pageURL.pathname) {
            return false
        }
        return true;
    } catch (err) {
        return false;
    }
}

function getLastView() {
    if (isMobile()) {
        return 'mobile';
    }
    if (isTablet()) {
        return 'tablet';
    }
    return 'desktop';
}

function isMobile() {
    return ($('#mobile-check').css('display') != "none");
}

function isTabletTouch() {
    return ($('#tab-check').css('display') != "none" || $('html').hasClass('touch'));
}

function isTablet() {
    return ($('#tab-check').css('display') != "none");
}

function isTouch() {
    return ('ontouchstart' in window || navigator.msMaxTouchPoints);
}

function isAndroid() {
    const userAgent = navigator.userAgent.toLowerCase();
    return (userAgent.indexOf("android") > -1);
}
function isMobileSafari() {
    const is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent);
    const is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    return ( is_ios && is_safari );
}
function isMacChrome() {
    // please note,
    // that IE11 now returns undefined again for window.chrome
    // and new Opera 30 outputs true for window.chrome
    // but needs to check if window.opr is not undefined
    // and new IE Edge outputs to true now for window.chrome
    // and if not iOS Chrome check
    // so use the below updated condition
    var isChromium = window.chrome;
    var winNav = window.navigator;
    var vendorName = winNav.vendor;
    var isOpera = typeof window.opr !== "undefined";
    var isIOSChrome = winNav.userAgent.match("CriOS");
    var isMac = winNav.platform.indexOf('Mac') > -1;
    if (isIOSChrome) {
        // is Google Chrome on IOS
    } else if(
        isChromium !== null &&
        typeof isChromium !== "undefined" &&
        vendorName === "Google Inc." &&
        isOpera === false &&
        isMac
    ) {
        // is Google Chrome
        return true;
    } else {
        // not Google Chrome
    }
    return false;
}

function isSafariDesktop() {
    //https://stackoverflow.com/questions/52204690/how-detect-safari-browser-only-on-desktop
    const uA = navigator.userAgent;
    const vendor = navigator.vendor;
    if (/Safari/i.test(uA) && /Apple Computer/.test(vendor) && !/Mobi|Android|iPad/i.test(uA)) {
        //isIOS im Desktop-Modus?
        if (isTouch()) {
            return false;
        }
        return true;
    }
    return false;
}

function startAnimations() {
    const scrollState = {
        top: true,
        topThreshold: 10,
        onScroll: function () {
            if (this.top && window.scrollY > this.topThreshold) {
                this.top = false;
                this.updateUI();
            } else if (!this.top && window.scrollY <= this.topThreshold) {
                this.top = true;
                this.updateUI();
            }
        },
        updateUI: function () {
            document.querySelector("header").classList.toggle("scroll");
        },
    };
    window.addEventListener("scroll", () => scrollState.onScroll());

    // https://ralfhoffmeister.de
    // Bsp.: wähle alle Elemente mit der Klasse ".scroll-fadein"
    const fadeInItems = document.querySelectorAll(".scroll-fadein");
    const observer = new IntersectionObserver(entries => {
        entries.forEach((entry, entryIndex) => {
            if (entry.isIntersecting) {
                // mehrere Elemente gleichzeitig ins Viewport kommen, delay um 50ms (entryIndex = index der observe - elemente im Viewport)...
                const delayForEntry = entryIndex * 50;
                setTimeout(() => {
                    // ...füge animations-klasse hinzu (CSS animationen)
                    entry.target.classList.add("is_visible");
                }, delayForEntry);
                // wenn Element eingeblendet ist, nicht mehr weiter überwachen (optional)
                observer.unobserve(entry.target);
            } else {
                // wenn nicht mehr im Viewport, Klasse wieder entfernen
                // WICHTIG: unobserve (Zeile 20) muss entfernt werden,
                //entry.target.classList.remove("is_visible");
            }
        });
    });
    fadeInItems.forEach(fadeInItem => {
        observer.observe(fadeInItem);
    });

    const slideInItems = document.querySelectorAll(".scroll-slidein");
    const observer2 = new IntersectionObserver(entries => {
        entries.forEach((entry, entryIndex) => {
            if (entry.isIntersecting) {
                // mehrere Elemente gleichzeitig ins Viewport kommen, delay um 300ms (entryIndex = index der observe - elemente im Viewport)...
                const delayForEntry = entryIndex * 300;
                setTimeout(() => {
                    // ...füge animations-klasse hinzu (CSS animationen)
                    entry.target.classList.add("is_visible");
                }, delayForEntry);
                // wenn Element eingeblendet ist, nicht mehr weiter überwachen (optional)
                //observer.unobserve(entry.target);
            } else {
                // wenn nicht mehr im Viewport, Klasse wieder entfernen
                // WICHTIG: unobserve (Zeile 20) muss entfernt werden,
                //entry.target.classList.remove("is_visible");
            }
        });
    });
    slideInItems.forEach(slideInItem => {
        observer2.observe(slideInItem);
    });

}


//Google Maps
function loadGoogleMaps() {
    try {
        if (1==1 || usercentricsCheckConsent("S1pcEj_jZX")) {
            if (typeof google === "object" && typeof google.maps === "object" && typeof google.maps.Geocoder === "function") {
                jQuery("#map").removeClass("disabled");
                initializeGoogleMaps();
                return true;
            } else {
                jQuery.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBUY0OJbW73KZ6erpPMn-tJ_5miC7K1FlI&callback=loadMaps", function(){
                    jQuery.getScript('/wp/wp-content/themes/rel_site/include/dist/assets/js-extra/maps.marker.label.js', function(){
                        jQuery("#map").removeClass("disabled");
                        initializeGoogleMaps();
                        return true;
                    });
                });
            }
        } else {
            jQuery("#map").addClass("disabled");
            return false;
        }
        throw "noconsent";
    }
    catch (e) {
        console.log(e);
        jQuery("#map").addClass("disabled");
        return false;
    }

}

function initializeGoogleMaps() {
    if ($('#map').length>0) {
        initialize();
        google.maps.event.addDomListener(window, "resize", function () {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });
    }
}

function initialize() {
    directionsDisplay = new google.maps.DirectionsRenderer({polylineOptions: {strokeColor: "#042f60"}});
    directionsService = new google.maps.DirectionsService();
    //var end = 'Eichelgasse 56 a, 97877 Wertheim , Germany';
    geocoder = new google.maps.Geocoder();
    var latlng = new google.maps.LatLng(49.7601521,9.5197708);
    var myOptions = {
        zoom: 13,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    }
    map = new google.maps.Map(document.getElementById("map"), myOptions);
    //geocoder.geocode( { "address": end}, function(results, status) {
    //if (status == google.maps.GeocoderStatus.OK) {
    //map.setCenter(results[0].geometry.location);
    map.setCenter(latlng);
    map.setOptions({styles: getMapStyle() });
    var marker = new MarkerWithLabel({
        position: latlng,
        map: map,
        draggable: false,
        raiseOnDrag: true,
        labelContent: "Zahnarztpraxis Dr. Thomas Bruckner und Dr. Martin Jahreis",
        labelAnchor: new google.maps.Point(-20, 40),
        labelClass: "map-labels", // the CSS class for the label
        labelInBackground: true,
    });
    marker.setMap(map);
    //}
    //});
}

//Google Maps Wegbestimmung
function calcRoute() {
    var start = document.getElementById("dstrasse").value+", "+document.getElementById("dort").value + ', Germany';
    var end = 'Bahnhofstraße 21, 97877 Wertheim, Germany';
    var request = {
        origin:start,
        destination:end,
        travelMode: google.maps.DirectionsTravelMode.DRIVING
    };
    directionsDisplay.setMap(map);
    directionsService.route(request, function(response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
            //console.log(response);
            directionsDisplay.setDirections(response);
        } else {
            alert('Adresse nicht gefunden!');
        }
    });
    return false;
}

function getMapStyle() {
    return [
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#CC071EFF"
                }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": "0"
                },
                {
                    "saturation": "0"
                },
                {
                    "color": "#f5f5f2"
                },
                {
                    "gamma": "1"
                }
            ]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "-3"
                },
                {
                    "gamma": "1.00"
                }
            ]
        },
        {
            "featureType": "landscape.natural.terrain",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#f9b519"
                },
                {
                    "lightness": 75
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 45
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fac9a9"
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text",
            "stylers": [
                {
                    "color": "#4e4e4e"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#787878"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "transit.station.airport",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "hue": "#0a00ff"
                },
                {
                    "saturation": "-77"
                },
                {
                    "gamma": "0.57"
                },
                {
                    "lightness": "0"
                }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#43321e"
                }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "hue": "#ff6c00"
                },
                {
                    "lightness": "4"
                },
                {
                    "gamma": "0.75"
                },
                {
                    "saturation": "-68"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#eaf6f8"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#c7eced"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "lightness": "-49"
                },
                {
                    "saturation": "-53"
                },
                {
                    "gamma": "0.79"
                }
            ]
        }
    ]

        ;
}
